import { pickBy, identity } from "lodash"

class GetChannelInstancesRequest {

    constructor({
        communityId,
        entityType,
        channelTypeId,
    }) {
        this.communityId = communityId
        this.entityType = entityType
        this.channelTypeId = channelTypeId
    }

    getPayload = () => {
        
        const payload = {
            "community_id": this.communityId,
            "entity_type": this.entityType,
            "channel_type_id": this.channelTypeId,
        }

        return pickBy(payload, identity)
    }
    
}

export default GetChannelInstancesRequest
